import { render } from "./SeamlessScroll.vue?vue&type=template&id=6100461a&scoped=true"
import script from "./SeamlessScroll.vue?vue&type=script&lang=js"
export * from "./SeamlessScroll.vue?vue&type=script&lang=js"

import "./SeamlessScroll.vue?vue&type=style&index=0&id=6100461a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6100461a"

export default script